import _objectSpread from "@babel/runtime-corejs3/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import isFunction from "lodash/isFunction";
import usePersist from "./usePersist";
import useSafeState from "./useSafeState";
function useSetState(initialState) {
  var _useSafeState = useSafeState(initialState),
    _useSafeState2 = _slicedToArray(_useSafeState, 2),
    state = _useSafeState2[0],
    setSafeState = _useSafeState2[1];
  var setState = usePersist(function (patch) {
    setSafeState(function (prevState) {
      var patchState = isFunction(patch) ? patch(prevState) : patch;
      return _objectSpread(_objectSpread({}, prevState), patchState);
    });
  });
  return [state, setState];
}
export default useSetState;